import React from 'react'
import { IntegrationServiceId } from '../../../../common/integrations'
import { ReactComponent as ZocksIcon } from '../../../../assets/ZocksIcon.svg'

import styled from 'styled-components'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'
import { creatorServiceToNameMap } from '../MeetingSummary/MeetingInfo/constants'
import { IntegrationIcon } from '../../../../components/IntegrationIcon'

export type CreatorService =
  | IntegrationServiceId.GOOGLE_CALENDAR
  | IntegrationServiceId.OUTLOOK_CALENDAR
  | IntegrationServiceId.EXCHANGE_CALENDAR
  | 'email'
  | IntegrationServiceId.REDTAIL
  | IntegrationServiceId.WEALTHBOX
  | 'voice-memo'
  | 'import'

const CreatorIconContainer = styled.div`
  svg {
    width: 1.25rem;
    height: 1.25rem;
    font-size: 1.25rem;
  }

  display: flex;
  align-items: center;
`

export const CreatorIcon: React.FC<{ creator: CreatorService; displayTooltip?: boolean }> = ({ creator, displayTooltip = true }) => {
  const iconMap = {
    [IntegrationServiceId.GOOGLE_CALENDAR]: <IntegrationIcon serviceId={IntegrationServiceId.GOOGLE_CALENDAR} />,
    [IntegrationServiceId.OUTLOOK_CALENDAR]: <IntegrationIcon serviceId={IntegrationServiceId.OUTLOOK_CALENDAR} />,
    [IntegrationServiceId.EXCHANGE_CALENDAR]: <IntegrationIcon serviceId={IntegrationServiceId.EXCHANGE_CALENDAR} />,
    [IntegrationServiceId.WEALTHBOX]: <IntegrationIcon serviceId={IntegrationServiceId.WEALTHBOX} />,
    [IntegrationServiceId.REDTAIL]: <IntegrationIcon serviceId={IntegrationServiceId.REDTAIL} />,
    email: <i className='bi bi-envelope-at-fill zocks-text-primary' />,
    'voice-memo': <ZocksIcon />,
    import: <ZocksIcon />,
  }

  return displayTooltip ? (
    <Tooltip title={creatorServiceToNameMap[creator]} placement='top'>
      <CreatorIconContainer>{iconMap[creator]}</CreatorIconContainer>
    </Tooltip>
  ) : (
    <CreatorIconContainer>{iconMap[creator]}</CreatorIconContainer>
  )
}
